import { Database } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';

interface AdminEmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ElementType;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Admin-flavoured wrapper over the one EmptyState.
 *
 * This used to be a full second implementation with its own markup, and it
 * had drifted: its action button was `bg-admin-emerald` with the default
 * light label, and admin-emerald is documented as DECORATIVE ONLY — 2.30:1,
 * unreadable as a filled button. Delegating means there is a single empty
 * state in the app, so a fix in one place is a fix everywhere.
 */
export function AdminEmptyState({
  title = 'No data available',
  description = 'There are no records to display at this time.',
  icon: Icon = Database,
  actionLabel,
  onAction,
}: AdminEmptyStateProps) {
  return (
    <EmptyState
      icon={Icon}
      title={title}
      description={description}
      actions={actionLabel && onAction ? [{ label: actionLabel, onClick: onAction }] : []}
    />
  );
}
